import { render, staticRenderFns } from "./ProductStatsCompare.vue?vue&type=template&id=6b8fe95e&scoped=true"
import script from "./ProductStatsCompare.vue?vue&type=script&lang=js"
export * from "./ProductStatsCompare.vue?vue&type=script&lang=js"
import style0 from "./ProductStatsCompare.vue?vue&type=style&index=0&id=6b8fe95e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8fe95e",
  null
  
)

export default component.exports